import PropTypes from "prop-types";
import styleSchema from "./Nav.styles";

const Nav = ({ size, label, selected, className, ...otherProps }) => (
  <button
    type="button"
    className={`${selected ? styleSchema.selected : styleSchema.regular} ${styleSchema[size]} ${className}`}
    {...otherProps}
  >
    {label}
  </button>
);

Nav.propTypes = {
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["medium", "small"]),
  selected: PropTypes.bool,
  className: PropTypes.string,
};

Nav.defaultProps = {
  size: "medium",
  selected: false,
  className: "",
};

export default Nav;
